import FinancialCenter from './FinancialCenter';

export default FinancialCenter;
